<template>
  <div>
    <el-button icon="el-icon-plus" type="primary" @click="dialogVisible = true">
      添加币种
    </el-button>
    <el-dialog
      :visible="dialogVisible"
      title="添加币种"
      width="1200px"
      @close="closeDialog"
    >
      <el-form :model="coinDetail" ref="coinForm" class="coin-form" :rules="rules" label-width="150px">
        <el-form-item label="币种：" prop="coinType">
          <el-input v-model="coinDetail.coinType"></el-input>
        </el-form-item>
        <el-form-item label="币种名称：" prop="coinName">
          <el-input v-model="coinDetail.coinName"></el-input>
        </el-form-item>
        <el-form-item label="Logo：" prop="logo">
          <upload v-model="coinDetail.logo" url="/admin/voteCoin/upload"></upload>
        </el-form-item>
        <el-form-item label="投票奖励：" prop="reward">
          <el-input v-model="coinDetail.reward"></el-input>
        </el-form-item>
        <el-form-item :label="`币种介绍（${lang.label}）：`" v-for="lang in languages" :key="lang.value">
          <editor v-model="coinDetail.introduction[lang.value]" class="editor"></editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('coinForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LANGUAGE from 'common/languages';
import Upload from 'components/upload';
import Editor from 'components/editor';
import { mapActions } from 'vuex';

export default {
  name: 'CreateCoin',
  components: {
    Upload,
    Editor
  },
  data() {
    const languageKeys = Object.keys(LANGUAGE);
    const introduction = {};

    languageKeys.forEach(item => {
      introduction[item] = '';
    });

    return {
      dialogVisible: false,
      languages: languageKeys.map(item => {
        return {
          label: LANGUAGE[item],
          value: Number(item)
        };
      }),
      coinDetail: {
        introduction
      },
      rules: {
        title: [{ required: true, message: '请输入标题' }],
        startTime: [{ required: true, message: '请输入开始时间' }],
        endTime: [{ required: true, message: '请输入结束时间' }]
      }
    };
  },
  methods: {
    ...mapActions('voteCoinSetting', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.$refs['coinForm'].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const introduction = Object.keys(this.coinDetail.introduction).map(
            item => {
              return {
                language: item,
                content: this.coinDetail.introduction[item]
              };
            }
          );

          this.create({
            ...this.coinDetail,
            introduction
          }).then(() => {
            this.$message.success('添加成功！');
            this.$emit('refresh');
            this.closeDialog = false;
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editor {
  height: 300px;
}
</style>
